import axios from 'axios'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { getToken } from '../user/User'

export const useTicket = (id) => {
    const [created, setCreated] = useState(0)
    const [createdFormatted, setCreatedFormatted] = useState("")
    const [assigned, setAssigned] = useState(null)
    const [assignedFormatted, setAssignedFormatted] = useState("")
    const [closed, setClosed] = useState(null)
    const [closedFormatted, setClosedFormatted] = useState("")
    const [comments, setComments] = useState([])
    const [state, setState] = useState("open")
    const [stateText, setStateText] = useState("")
    const [creator, setCreator] = useState("")
    const [creatorName, setCreatorName] = useState("")
    const [supporter, setSupporter] = useState("")
    const [supporterName, setSupporterName] = useState("")
    const [server, setServer] = useState("")
    const [world, setWorld] = useState("world")
    const [x, setX] = useState(0)
    const [y, setY] = useState(64)
    const [z, setZ] = useState(0)
    const [category, setCategory] = useState("")
    const [request, setRequest] = useState("")
    const [answer, setAnswer] = useState("")
    useEffect(() => {
        if(id !== null) {
            const abortCont = new AbortController()
            
            axios.get(process.env.REACT_APP_API_URL + "/api/tickets/" + id, {
                signal: abortCont.signal,
                headers: {
                    "Authorization": "Bearer " + getToken()
                }
            }).then(res => {
                setAnswer(res.data.answer === null ? "" : res.data.answer)
                setCategory(res.data.category)
                setCreated(res.data.created)
                setCreatedFormatted(res.data.created_formatted)
                // A ticket which was never assigned or is still open has no such time
                setAssigned(res.data.assigned === undefined ? null : res.data.assigned)
                setAssignedFormatted(res.data.assigned_formatted == null ? "" : res.data.assigned_formatted)
                setClosed(res.data.closed === undefined ? null : res.data.closed)
                setClosedFormatted(res.data.closed_formatted == null ? "" : res.data.closed_formatted)
                setComments(res.data.comments == null ? [] : res.data.comments)
                setCreator(res.data.creator)
                setCreatorName(res.data.creator_name)
                setRequest(res.data.request)
                setServer(res.data.server)
                setState(res.data.state)
                setStateText(res.data.state_text)
                setSupporter(res.data.supporter === null ? "" : res.data.supporter)
                setSupporterName(res.data.supporter_name === null ? "" : res.data.supporter_name)
                setWorld(res.data.world)
                setX(res.data.x)
                setY(res.data.y)
                setZ(res.data.z)
            }).catch(error => {
                console.error(error)
                if(axios.isCancel(error)) {
                  return
                }
                if (error.response) {
                    var statusCode = error.response.status
                    if(statusCode === 400) {
                        toast.error("Ungültige Anfrage.")
                        return
                    } else if(statusCode === 404) {
                        toast.error("Es existiert kein Tikcet mit der Id " + id + ".")
                        return
                    }
                }
                toast.error("Serverfehler")
            })
        
            return () => abortCont.abort()
        }
    }, [id])

    return { created, setCreated, createdFormatted, setCreatedFormatted, assigned, setAssigned, assignedFormatted, setAssignedFormatted, closed, setClosed,
        closedFormatted, setClosedFormatted, comments, setComments, state, setState, stateText, setStateText, creator, setCreator, creatorName, setCreatorName, supporter, setSupporter, 
        supporterName, setSupporterName, server, setServer, world, setWorld, x, setX, y, setY, z, setZ, category, setCategory, request, setRequest, answer, setAnswer }
}